
import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import appLogo from '../../assets/logoFinal-removebg-preview.png';
import { FiMenu, FiX } from 'react-icons/fi';
import { useSelector } from 'react-redux';

const menuItems = [
  { label: "Home", path: "/" },
  { label: "Why 1800hired", path: "/why-us" },
  { label: "Resources", path: "/resource" },
  { label: "About", path: "/about-us" },
  { label: "Community",  path: "/community" },
]

const NavBar = () => {
  const navigate = useNavigate();
  const location=useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const token = useSelector((state) => state.auth.token)
  const user = useSelector((state) => state.profile.user);

  const firstPermittedPath = user?.roles
    ?.flatMap(role => role.permissions || [])
    ?.filter((perm, index, self) =>
      index === self.findIndex(p => p.path === perm.path)
    )?.[0]?.path;


  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 1024) {
        setMenuOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <nav className='home-navbar'>
      <div className='home-navbar-container'>
        <div className='home-navbar-left'>
          <img src={appLogo} alt='appLogo' onClick={() => navigate("/")} className='app-logo' style={{ width: "178px", height: "52px", marginLeft: "-10px", cursor: "pointer" }} />
          <ul className='home-menu-list'>
            {menuItems.map((item, index) => (
              <li
                key={index}
                onClick={() => navigate(item.path)}
                className={location.pathname === item.path ? 'active-menu-header' : ''}
                style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px' }}
              > {item.label}
              </li>
            ))}
          </ul>
        </div>

        <div className='home-navbar-right'>
          {token && firstPermittedPath ? (
            <button className='demo-btn' style={{ minWidth: "150px" }} onClick={() => navigate(firstPermittedPath)}>
              Go to Dashboard
            </button>
          ) : (
            <>
              <button className='get-started-btn' onClick={() => navigate("/get-started")}>
                Get started
              </button>
              <button className='demo-btn' onClick={() => navigate("/login")}>Login</button>
            </>
          )}
        </div>


        {/* Hamburger Icon for Small Screens */}
        <div className='hamburger-menu' onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? <FiX size={28} /> : <FiMenu size={28} />}
        </div>
      </div>
      <div className={`mobile-menu ${menuOpen ? "open" : ""}`}>
        <ul className='mobile-menu-list'>
          {menuItems.map((item, index) => (
            <li
      key={index}
      onClick={() => {
        navigate(item.path);
        setMenuOpen(false);
      }}
      className={location.pathname === item.path ? 'active-menu-header' : ''}
      style={{ display: 'flex', alignItems: 'center', gap: '6px' }}
    >{item.label}
    </li>
          ))}
        </ul>
        <div className='mobile-menu-buttons'>
          <button className='demo-btn'>Login</button>
          <button className='get-started-btn' onClick={() => navigate("/get-started")}>
            Get started
          </button>
        </div>
      </div>
    </nav>
  );
};

export default NavBar;
